{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.71.0",
	"hash": "fe8bb8e1ae6a9539ebf04afcadd0f1e62a08ee4c"
}
